import { render, staticRenderFns } from "./CampanhaPromocao.vue?vue&type=template&id=da891f8a&scoped=true&lang=pug"
import script from "./CampanhaPromocao.vue?vue&type=script&lang=js"
export * from "./CampanhaPromocao.vue?vue&type=script&lang=js"
import style0 from "./CampanhaPromocao.vue?vue&type=style&index=0&id=da891f8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da891f8a",
  null
  
)

export default component.exports